import { useStore, selectActiveClip } from '../store'

/** Transcript của clip đang active — trái tim của "text-based editing". */
export function TranscriptPanel() {
  const clip = useStore(selectActiveClip)
  const currentTime = useStore((s) => s.currentTime)
  const toggleWord = useStore((s) => s.toggleWord)

  if (!clip) return null

  if (!clip.transcribed) {
    return (
      <div className="transcript empty">
        <p>
          Clip <b>{clip.name}</b> chưa có transcript.
        </p>
        <p className="muted">
          Nhấn <b>“🎙️ Phiên âm (AI)”</b> trên thanh công cụ. Sau đó <b>click vào từng chữ</b> để cắt
          đúng đoạn đó khỏi clip.
        </p>
      </div>
    )
  }

  const fillerCount = clip.words.filter((w) => w.isFiller && !w.removed).length

  return (
    <div className="transcript">
      <div className="transcript-hint">
        <b>{clip.name}</b> — click chữ để cắt/khôi phục. Chữ vàng = từ đệm ({fillerCount}).
      </div>
      <div className="words">
        {clip.words.map((w) => {
          const active = currentTime >= w.start && currentTime < w.end
          const cls = [
            'word',
            w.removed ? 'removed' : '',
            w.isFiller && !w.removed ? 'filler' : '',
            active ? 'active' : '',
          ]
            .filter(Boolean)
            .join(' ')
          return (
            <span
              key={w.id}
              className={cls}
              title={`${w.start.toFixed(2)}s – ${w.end.toFixed(2)}s`}
              onClick={() => toggleWord(w.id)}
            >
              {w.text}
            </span>
          )
        })}
      </div>
    </div>
  )
}
